import { CSKhamChuaBenh } from "../models/ModelSoKhamChuaBenh"

export const INITIAL_VALUE: CSKhamChuaBenh = {
  maCoSo: '',
  tenCoSo: '',
  tuyen: '',
}

export const CSKhamChuaBenhData: CSKhamChuaBenh[] = [
  {
    id: '1111111111111111',
    maCoSo: 'cs1',
    tenCoSo: 'cơ sở 1',
    tuyen: 'tuyến 1'
  },
  {
    id: '22222222222222222',
    maCoSo: 'cs2',
    tenCoSo: 'cơ sở 2',
    tuyen: 'tuyến 2'
  },
  {
    id: '33333333333333333',
    maCoSo: 'cs3',
    tenCoSo: 'cơ sở 3',
    tuyen: 'tuyến 3'
  },
  {
    id: '44444444444444444',
    maCoSo: 'cs4',
    tenCoSo: 'cơ sở 4',
    tuyen: 'tuyến 4'
  },
  {
    id: '55555555555555555',
    maCoSo: 'cs5',
    tenCoSo: 'cơ sở 5',
    tuyen: 'tuyến 5'
  },
]